import ValidationModule from "~/entities/ValidationModule";
import AlertRequestQuery from "~/entities/AlertRequestQuery";

export default class ValidationClaim extends ValidationModule{

  public claimAlerts = {
    selector: {
    },
    needle: ['']
  }

  public constructor(){
    super('');
    this.resetValidations();
    this.alertNames = [
      '',//
    ]
    this.alertTypes = {
      //fill
      claimAlerts: this.claimAlerts
    }
  }

  public async Validate(scope:string=''){
      this.resetValidations();
      let errors = 0;

      // console.log(this.component?.claimForm);
      switch (scope) {

        case 'claim':

          let { OrderId, TrackingNumber, Email, Phone, FirstName, LastName, IsSender, BillOfSalePics, DamageOrLoss, InsidePics, OutsidePics, PackingPics, Description, ContentDescription} = this.component?.claimForm;

          if (!FirstName || !LastName || !Email || !Phone || !TrackingNumber || !OrderId || IsSender == null || !BillOfSalePics || !ContentDescription ){
            errors++;
            this.validationErrors.push('claim-required');

          }
          if( DamageOrLoss !== 'loss'){

            if(!OutsidePics){
              errors++;
              this.validationErrors.push('claim-outsidePics');
            }

            if(!PackingPics) {
              errors++;
              this.validationErrors.push('claim-packingPics');
            }

            if (!Description) {
              errors++;
              this.validationErrors.push('claim-description');
            }
          }

          if (DamageOrLoss === 'damage') {
            if(!InsidePics){
              errors++;
              this.validationErrors.push('claim-insidePics');
            }
          }

          if(!this.validatePhoneNumber(this.component?.claimForm.Phone)){
            errors++;
            this.validationErrors.push('claim-validPhone');
          }
          if(!this.validateEmail(this.component?.claimForm.Email)){
            errors++;
            this.validationErrors.push('claim-validEmail');
          }
        break;
      }
      if(errors == 0){
        this.validated = true;
        this.validationMade = true;
      }else{
        this.validated = false;
        this.validationMade = true;
      }
      return !errors;
  }
  public resetValidations(){
      this.validated = false;
      this.validationMade = false;
      this.validationErrors = [];
      this.component?.clearActiveNotices();
  }
  public requestAlert(data:any) {
    this.component?.requestAlert(this.getFilteredAlertKey(data,'asObject'));
  }
  public addNotice(data:any) {
    this.component?.addNotice(this.getFilteredAlertKey(data));
  }
  public removeNotice(data:any) {
    this.component?.removeNotice(this.getFilteredAlertKey(data));
  }
  protected getFilteredAlertKey(data:any, returnType:string = 'asString'):any{
    let keyGetter = new AlertRequestQuery();
    if(data.hasOwnProperty('type')){
      switch (data.type) {
        case 'claim':
          keyGetter.name = this.alertTypes[data.type].selector[data.name];
          keyGetter.typeSelector = data.name;
        break;
      }
    }else{
      //fill
    }
    let filteredData = keyGetter.getKey(this.alertNames, this.alertTypes[data.type]);
    if(returnType == 'asString'){
      return filteredData.name;
    }else{
      return filteredData;
    }
  }

  public validatePhoneNumber(phone:string){
    phone = String(phone);
    let validatePhoneString = phone?.replace(/[#+-.() ]/g, '');
    return validatePhoneString && validatePhoneString.length > 5;
  }
  public validateEmail(email:string){
    // console.log(email);

    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }

}
